import React from 'react';

import LayoutProfile from './Partials/LayoutProfile';

const ProfileData: React.FC = () => <LayoutProfile />;

export default ProfileData;
